import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import digital3 from '../../assets/image/digital/digital3.png'
import info_graphic from '../../assets/image/digital-learning/info_graphic.jpg'
export default class motion_graphic extends Component {
    render() {
        const image=[
            {image:info_graphic}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Digital Learning','Infographic Animation']} image={image} title="Infographic Animation (Motion Graphic)" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Design your information in an attractive way and gain the attention of your audiences with a simple animated simulation to delivered your objective. We will help you to featured up and designing your visual information.
                                <br/><br/>
                                <img src={digital3}/>
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
